import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { createPortal } from "react-dom";
import { CacheProvider } from "@emotion/core";
import createCache from "@emotion/cache";
import Global from "./Global";
import { css } from "./Theme";
const {
  useEffect,
  useState,
  useRef,
  useMemo
} = React;

const FrameInternals = props => {
  const frameRef = useRef(null);
  const [data, setData] = useState({
    head: null,
    mount: null,
    rendered: false
  });

  const emotionCache = container => useMemo(() => createCache({
    container,
    key: "frame-css"
  }), [container]);

  useEffect(() => {
    const headNode = frameRef.current.contentDocument.head;
    const mountNode = frameRef.current.contentDocument.body;
    setData({ ...data,
      mount: mountNode,
      head: headNode,
      rendered: true
    });
  });
  const frameStyles = css({
    p: 0,
    m: "0px",
    border: "none",
    background: "white"
  });
  return ___EmotionJSX("iframe", _extends({}, props, {
    width: props.width,
    height: props.height,
    css: frameStyles,
    ref: frameRef
  }), ___EmotionJSX(CacheProvider, {
    value: emotionCache(data.head)
  }, data.rendered && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Global, null), createPortal(props.children, data.mount))));
};

export default FrameInternals;